import(/* webpackMode: "eager" */ "/app/app/prieto/page.tsx");
